import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Collection from "../components/Collection";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { listUsers } from "../actions/userActions";
import {
  USER_LIST_ALL_RESET,
  USER_LIST_RESET,
} from "../constants/userConstants";
import BlueLayout from "../layouts/BlueLayout";
import Curve from "../components/global/Curve";
import AppHero from "../components/global/AppHero";
import Search from "../components/global/Search";
import { categories } from "../constants/categories";
import AppAccordion from "../components/global/AppAccordion";

const OurNetworkScreen = () => {
  const dispatch = useDispatch();

  const [collection, setCollection] = useState([]);
  const [categoriesDrawer, setCategoriesDrawer] = useState(false);

  const userList = useSelector((state) => state.userList);
  const { loading, error, users } = userList;

  useEffect(() => {
    dispatch({ type: USER_LIST_RESET });
    dispatch({ type: USER_LIST_ALL_RESET });
    setTimeout(() => {
      dispatch(listUsers("partner"));
    }, 500);
  }, [dispatch]);

  useEffect(() => {
    if (
      users &&
      [...new Set(users.map((user) => user.type))][0] === "partner"
    ) {
      console.log(users);
      setCollection(
        users.sort(function (a, b) {
          if (
            a.head.name.toString().toLowerCase() <
            b.head.name.toString().toLowerCase()
          ) {
            return -1;
          }
          if (
            a.head.name.toString().toLowerCase() >
            b.head.name.toString().toLowerCase()
          ) {
            return 1;
          }
          return 0;
        })
      );
    }
  }, [users]);

  return (
    <BlueLayout>
      {loading && <Loader />}
      {error && <Message body={error} />}
      {loading ? (
        <Loader />
      ) : error ? (
        <Message body={error} />
      ) : (
        <div className="bg-night-blue">
          <AppHero
            titleWhite="OUR PARTNERS"
            titleCanton="OUR PRIDE"
            imgSrc={require("../assets/images/our-network/our-network.png")}
            paragraph="We partner with museums, Indigenous communities, heritage sites, science centres, art galleries, and more to bring a wealth of knowledge and experience to BC students and teachers. Every day we are reaching out to new potential partners to increase the variety of stories that are shared through The VR Voyage Classroom platform. A community representing the full spectrum of our provice. Explore a few of our partners below."
            linkBtn="/"
            textBtn="Become a partner"
            styleImg="xl:absolute xl:right-0 xl:max-w-[734px]"
          />
          <div className="bg-night-blue mt-24">
            <h2 className="text-center mb-8 text-canton-jadesheen ">
              NEW PARTNERING ORGANIZATIONS
            </h2>
            {collection?.length && (
              <Collection
                isInfinite
                speed="120s"
                collectionType="partners"
                items={users}
              />
            )}
          </div>
          <div className="-mt-36">
            <Curve color="--var-color-vrc-creamy-beige" />
          </div>
          <div className="bg-creamy-beige pt-36">
            <div className="container">
              <h2 className="text-center text-canton-jadesheen mb-8">
                All Our Partners
              </h2>
              <Search
                type="Partner"
                className="mt-0 mb-20"
                collectionClass="-top-12 md:-top-0"
                prepend={
                  <button
                    className="ml-1"
                    onClick={() => setCategoriesDrawer(true)}
                  >
                    <i
                      className="iconify font-bold"
                      data-icon="mi:filter"
                      data-rotate="180deg"
                    />
                  </button>
                }
                inputClass="grid md:flex md:items-center rounded-[10px] md:bg-white md:gap-3 md:pr-5 h-16 border-transparent outline-double"
              />
              {categoriesDrawer && (
                <aside className="overflow-auto fixed top-0 left-0 h-screen w-[96%] md:w-96 py-5 px-5 bg-white z-50">
                  <div className="grid px-4 pb-12">
                    {categoriesDrawer && (
                      <aside className="overflow-auto fixed top-0 left-0 h-screen w-[96%] md:w-96 py-5 px-5 bg-creamy-beige z-50">
                        <div className="flex mb-5">
                          <div className="mr-2 flex items-center gap-3">
                            <i
                              className="iconify font-bold"
                              data-icon="mi:filter"
                              data-rotate="180deg"
                            />
                            <h3 className="font-bold text-lg">Categories</h3>
                          </div>
                          <button
                            className="ml-auto"
                            onClick={() => setCategoriesDrawer(false)}
                          >
                            <i
                              className="iconify text-xl"
                              data-icon="heroicons-solid:x"
                            />
                          </button>
                        </div>

                        <div className="grid px-4 pb-12">
                          {categories.map((category) => (
                            <div className="mb-3 font-bold" key={category.name}>
                              <AppAccordion
                                header={<p>{category.name}</p>}
                                headerClass="mb-3"
                              >
                                <div className="space-y-1">
                                  {category.types.map((type, i) =>
                                    type.name ? (
                                      <AppAccordion
                                        key={i}
                                        header={<p>{type.name}</p>}
                                        headerClass="mb-3"
                                      >
                                        {type.items?.map((item) => (
                                          <li
                                            key={item.name}
                                            className="list-none"
                                          >
                                            <button className="flex gap-4 py-2">
                                              <i
                                                className={`iconify text-denim ${item.styleIcon}`}
                                                data-icon={item.icon}
                                              />
                                              <span>{item.name}</span>
                                            </button>
                                          </li>
                                        ))}
                                      </AppAccordion>
                                    ) : (
                                      type.items.map((item) => (
                                        <li
                                          key={item.name}
                                          className="list-none"
                                        >
                                          <button className="flex gap-4 py-2">
                                            <i
                                              className={`iconify text-denim ${item.styleIcon}`}
                                              data-icon={item.icon}
                                            />
                                            <span>{item.name}</span>
                                          </button>
                                        </li>
                                      ))
                                    )
                                  )}
                                </div>
                              </AppAccordion>
                            </div>
                          ))}
                        </div>
                      </aside>
                    )}
                  </div>
                </aside>
              )}

              <div className="flex flex-wrap gap-6 justify-around lg:justify-start pb-24 xl:pb-36">
                {collection.map((item, index) => (
                  <div className="grayscale w-28" key={index}>
                    <img src={item.head.avatar} alt={item.website} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      <Curve color="--var-color-vrc-night-blue" />
    </BlueLayout>
  );
};

export default OurNetworkScreen;
